<template>
  <div>
    <b-overlay
      :show="isLoading"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      @shown="onShown"
      @hidden="onHidden"
    >
      <section
        class="invoice-preview-wrapper"
        style="position: relative"
      >
        <!-- Alert: No item found -->
        <b-alert
          variant="danger"
          :show="order === undefined"
        >
          <h4 class="alert-heading">
            Error fetching invoice data
          </h4>
          <div class="alert-body">
            No invoice found with this invoice id. Check
            <b-link
              class="alert-link"
              :to="{ name: 'facture-list' }"
            >
              invoice List
            </b-link>
            for other invoice.
          </div>
        </b-alert>
        <div
          v-if="isLoading === true"
          class="text-center mb-2"
        >
          <b-spinner
            variant="primary"
            label="Text Centered"
          />
        </div>
        <b-row
          v-if="allOrders && allOrders.length > 0"
          class="invoice-preview"
        >

          <!-- Col: Left (Invoice Container) -->
          <b-col
            cols="12"
            xl="9"
            md="8"
          >
            <template
              v-for="orderItem in allOrders"
            >
              <b-card
                :id="orderItem.id"
                :key="orderItem.id"
                no-body
                class="invoice-preview-card pagebreak"
              >
                <div
                  class="d-flex justify-content-between flex-wrap mr-1 ml-1"
                >

                  <div class="invoice-preview">
                    <h1
                      class="mt-1"
                      style="color: #E80000; font-size: 30px"
                    >
                      Bon de livraison
                      <span

                        class="invoice-title invoice-number"
                        style="color: #E80000;"
                      >
                        N° : BL-{{ orderItem.id }}
                      </span>
                    </h1>
                    <h6 style="color: black ">
                      Date :
                      <span
                        class="invoice-date"
                        style="color: black"
                      >
                        {{ formatFn(orderItem.created_at) }}</span>
                    </h6>
                    <div class="d-flex justify-content-between mt-1">
                      <div
                        v-if="orderItem.external_id"
                        class="mx-2"
                      >
                        <qrcode-vue
                          :value="orderItem.external_id.toString()"
                          :size="size"
                          level="H"
                        />
                        <span>{{ orderItem.external_id }}</span>
                      </div>
                      <div
                        v-if="orderItem.external_id"
                        class="mx-2"
                      >
                        <barcode :value="orderItem.external_id.toString()" />
                      </div>
                    </div>

                  </div>

                  <div style="text-align:end">
                    <div>
                      <img
                        src="@/assets/images/logo/logo.png"
                        width="250px"
                        height="100%"
                      >
                    </div>
                    <div class="mt-1">
                      <b-card-text
                        class="h4"
                        style="color: black"
                      >
                        <strong
                          style="color:#E80000"
                        >{{ company.name }} :</strong> {{ company.tagline || 'Société de livraison des colis' }}
                      </b-card-text>
                      <b-card-text
                        class="h4"
                        style="color: black"
                      >
                        <strong
                          style="color:#E80000"
                        >Matricule fiscale :</strong> {{ company.tax_identification_number ? '***' + company.tax_identification_number.slice(3)
                          : '' }}
                      </b-card-text>
                      <b-card-text
                        class="h4"
                        style="color: black"
                      >
                        <strong
                          style="color:#E80000"
                        >Adresse :</strong> {{ company.address }}
                      </b-card-text>
                      <b-card-text
                        class="h4"
                        style="color: black"
                      >
                        <strong
                          style="color:#E80000"
                        >Tel :</strong> {{ company.phone1 }}
                      </b-card-text>

                    </div>

                  </div>
                </div>
                <b-card-text
                  v-if="orderItem.is_an_exchange ==true"
                  class="h4 ml-1 text-center p-1"
                  style="color:black;font-size: 25px; border:1px solid black"
                  aria-label="Colis en échange"
                >
                  <strong style="color:#E80000">Échange</strong>
                </b-card-text>
                <b-card-text
                  v-if="orderItem.is_fragile ==true"
                  class="h4 mx-1 text-center p-1"
                  style="color:black;font-size: 50px; border:1px solid black"
                  aria-label="Colis fragile"
                >
                  <strong style="color:#BC2B18">Fragile</strong>
                </b-card-text>
                <div class="d-flex flex-row justify-content-between mr-1 ml-1 mb-1">

                  <div>

                    <div
                      style="border: 2px solid black;font-size: 26px;"
                    >
                      <b-card-text class="ml-2 mr-2 mt-2 mb-1 font-weight-bold">
                        <span
                          style="font-weight:900; color: #E80000"
                        >Client : </span> {{ orderItem.name }}
                      </b-card-text>
                      <b-card-text class="ml-2 mr-2 mb-1">
                        <span
                          style="font-weight:900; color: #E80000"
                        >Gouvernorat : </span>{{ typeof orderItem.governorate === 'object' ? orderItem.governorate.name : orderItem.governorate }}
                        <span v-if="orderItem.delegation"> , {{ typeof orderItem.delegation === 'object' ? orderItem.delegation.name : orderItem.delegation }}</span>
                      </b-card-text>

                      <b-card-text class="ml-2 mr-2 mb-1">
                        <span style="font-weight:900; color: #E80000">Adresse :</span>
                        {{ orderItem.address ? (orderItem.address.length > 40 ? orderItem.address.slice(0, 40) + '...' : orderItem.address) : '' }}
                      </b-card-text>
                      <b-card-text class="ml-2 mr-2 mb-1">
                        <span
                          style="font-weight:900; color: #E80000"
                        > téléphone :</span>
                        {{ orderItem.phone1 }} / {{ orderItem.phone2 }}
                      </b-card-text>
                    </div>
                  </div>
                  <div>

                    <div
                      class="ml-2"
                      style="border: 2px solid black;font-size: 14px;"
                    >

                      <b-card-text class="ml-2 mr-2 mt-2 mb-1 font-weight-bold">
                        <span
                          style="font-weight:900; color: #E80000"
                        >Fournisseur :</span> {{ orderItem.supplier.username }}
                      </b-card-text>
                      <b-card-text class="ml-2 mr-2 mb-1">
                        <span
                          style="font-weight:900; color: #E80000"
                        >Téléphone : </span>{{ orderItem.supplier.phone }} / {{ orderItem.supplier.phone2 }}
                      </b-card-text>
                      <b-card-text class="ml-2 mr-2 mb-1">
                        <span
                          style="font-weight:900; color: #E80000"
                        >Adresse :</span>
                        {{ orderItem.supplier.address }}
                      </b-card-text>
                      <b-card-text class="ml-2 mr-2 mb-1">
                        <span style="font-weight:900; color: #E80000">Matricule Fiscale :</span>
                        {{
                          orderItem.supplier.tax_identification_number
                            ? '***' + orderItem.supplier.tax_identification_number.slice(3)
                            : ''
                        }}
                      </b-card-text>
                    </div>
                  </div>

                </div>

                <!-- Invoice Description: Table -->
                <div class="mr-1 ml-1">
                  <b-table-lite
                    class="ta"
                    style="font-size: 20px; border: 2px solid black"
                    responsive
                    :items="orderItem.p"
                    :fields="['désignation', 'quantité']"
                  >
                    <template #cell(taskDescription)="data">
                      <b-card-text class="font-weight-bold mb-25">
                        {{ data.item.taskTitle }}
                      </b-card-text>
                      <b-card-text class="text-nowrap">
                        {{ data.item.taskDescription }}
                      </b-card-text>
                    </template>
                  </b-table-lite>
                </div>

                <div class="mr-1 ml-1">
                  <b-row>
                    <b-col>
                      <h1
                        style="color: #E80000; font-size: 18px ; font-weight: bold"
                      >
                        Commentaire :
                        <span
                          style="font-size: 15px ; color:black;"
                        >
                          {{ orderItem.note }}
                        </span>
                      </h1>
                      <!-- <p v-if="orderItem.external_supplier_name && orderItem.external_supplier_phone">
                      Fournisseur Externe: {{ orderItem.external_supplier_name }} - {{ orderItem.external_supplier_phone }}
                    </p> -->
                      <div>
                        <b-card-text
                          v-if="orderItem.is_an_exchange ==true"
                          class="h4"
                          style="color:black"
                        >
                          <feather-icon
                            icon="RefreshCwIcon"
                            size="18"
                            class="mr-50"
                            style="color: #5A8DEE;"
                          />
                          <strong style="color:#E80000">Échange :</strong> OUI
                        </b-card-text>
                        <b-card-text
                          v-if="orderItem.is_fragile ==true"
                          class="h4"
                          style="color:black"
                        >
                          <feather-icon
                            icon="AlertTriangleIcon"
                            size="18"
                            class="mr-50"
                            style="color: #FDAC41;"
                          />
                          <strong style="color:#E80000">Fragile :</strong> OUI
                        </b-card-text>
                        <b-card-text
                          v-if="orderItem.is_discharge == true"
                          class="h4"
                          style="color:black"
                        >
                          <feather-icon
                            icon="FileTextIcon"
                            size="18"
                            class="mr-50"
                            style="color: #A3A1FB;"
                          />
                          <strong style="color:#E80000">Décharge :</strong> OUI
                        </b-card-text>
                        <b-card-text
                          v-if="orderItem.can_open_package == true"
                          class="h4"
                          style="color:black"
                        >
                          <feather-icon
                            icon="PackageIcon"
                            size="18"
                            class="mr-50"
                            style="color: #C59C6C;"
                          />
                          <strong style="color:#E80000">Possibilité d'ouverture du colis :</strong> OUI
                        </b-card-text>
                      </div>
                      <br>
                      <div class="mx-2">
                        <qrcode-vue
                          :value="orderItem.id.toString()"
                          :size="size"
                          level="H"
                        />
                        <span>{{ orderItem.id }}</span>
                      </div>
                    </b-col>

                    <b-col
                      class="ml-2"
                      style="font-size: 20px"
                    >
                      <table
                        style="border: 2px solid #E80000"
                      >
                        <tr class="badge-glow bg-info bg-lighten-5">
                          <th class="text-center">
                            Montant HT: {{ orderItem.price_ht }}
                          </th>
                        </tr>
                        <tr class="badge-glow bg-primary bg-lighten-5"><th class="text-center">TVA 7 %: {{ orderItem.tax }}
                        </th></tr>
                        <tr class="badge-glow bg-success bg-lighten-1"> <th class="text-center">Total TTC: {{ orderItem.price_ttc }} DT
                        </th></tr>

                      </table>
                    </b-col>

                  </b-row>
                </div>
              </b-card>

            </template>
          </b-col>

          <!-- Right Col: Card -->
          <b-col
            cols="12"
            md="4"
            xl="3"
            class="invoice-actions"
          >
            <b-card>
              <!-- Button: Print -->
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                :disabled="isLoading"
                variant="outline-secondary"
                class="mb-75"
                block
                @click="printInvoice"
              >
                Imprimer
              </b-button>

              <!-- Button: Edit -->
            </b-card>
          </b-col>
        </b-row>
      </section>
      <template #overlay>
        <div class="text-center">
          <b-icon
            icon="stopwatch"
            font-scale="3"
            animation="cylon"
          />
          <p id="cancel-label">
            Veuillez patienter...
          </p>
          Génération des bon des livraison en cours
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BRow,
  BCol,
  BCard,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BSpinner,
  BOverlay,
  BIcon,
} from 'bootstrap-vue'
import QrcodeVue from 'qrcode.vue'
import VueBarcode from 'vue-barcode'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import storeAuth from '@/store/store'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    QrcodeVue,
    barcode: VueBarcode,
    BSpinner,
    BOverlay,
    BIcon,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['orderIds'],
  data() {
    return {
      size: 100,
      p: [],
      order: [],
      allOrders: [],
      company: {},
      isLoading: false,
      show: false,
    }
  },

  created() {
    this.company = storeAuth.state.company
    this.getOrders()
  },
  methods: {
    formatFn(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)

      return `${year}-${month.padStart(2, '0')}-${day1.padStart(2, '0')}`
    },

    formatDate(date) {
      if (!date) {
        return null
      }
      const [year] = date.split('-')
      return `${year.slice(2, 4)}`
    },

    addnewitem(qte, nom) {
      this.p.push({
        désignation: nom,
        quantité: qte,
      })
    },
    async getOrders() {
      this.isLoading = true
      try {
        // Parse order IDs from route parameter
        const orderIds = this.orderIds ? this.orderIds.split(',') : []

        if (orderIds.length === 0) {
          // Show error message - no orders selected
          console.warn('No delivery notes selected')
          this.isLoading = false
          return
        }

        // Make single API call to get all orders
        const response = await axios.post('/api/orders/bulk-delivery-notes/', {
          order_ids: orderIds,
        })

        if (response.data && response.data.orders) {
          this.allOrders = response.data.orders.map(order => ({
            ...order,
            // Process products for each order (keep the existing logic)
            p: order.processed_products || [],
          }))
        }
      } catch (error) {
        console.error('Error fetching orders:', error)
        // Show error message
        console.warn('Error loading delivery notes')
      } finally {
        this.isLoading = false
      }
    },
    onShown() {
      // Focus the cancel button when the overlay is showing
      // this.$refs.cancel.focus()
    },
    onHidden() {
      // Focus the show button when the overlay is removed
      // this.$refs.show.focus()
    },
  },
  setup() {
    const invoiceData = ref(null)
    const paymentDetails = ref({})

    const printInvoice = () => {
      window.print()
    }

    return {
      invoiceData,
      paymentDetails,
      printInvoice,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
table,
td,
th {
  padding: 10px;
  text-align: left;
  border: 1px solid black;
}

table {
  width: 100%;
  border-collapse: collapse;
}
.mycolor{
    background-color:#EA2F2F ;
  }
.contact {
  background-color: #EA2F2F;
  padding: 10px;
  border-radius: 20px;
}
</style>

<style lang="scss">
@media print {
  @page {
    margin: 0 !important;
    padding: 0 !important;
    size: A4 portrait;
  }

  * {
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  html, body {
    height: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .pagebreak {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    height: 50vh !important;
    max-height: 50vh !important;
    min-height: 50vh !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;

    // Force page break after every 2nd delivery note
    &:nth-child(2n) {
      page-break-after: always !important;
      break-after: page !important;
    }

    // Handle variable content sizing
    .h4 {
      font-size: 14px !important;
      line-height: 1.1 !important;
      margin: 1px 0 !important;
      padding: 1px !important;
    }

    .h6 {
      font-size: 12px !important;
      line-height: 1.1 !important;
      margin: 1px 0 !important;
    }

    // Compact exchange and fragile banners
    .text-center.p-1 {
      padding: 2px !important;
      margin: 2px 0 !important;
      font-size: 16px !important;
      line-height: 1 !important;
    }

    // Ensure content fits within the container
    > div {
      flex-shrink: 1 !important;
    }
  }

  .ta {
    white-space: nowrap;
    overflow-x: visible;
    font-size: 18px !important;
    color: black;
  }

  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto;
  }

  .table thead th {
    border-bottom: 2px solid black;
  }

  body {
    background-color: transparent !important;
  }

  nav.header-navbar {
    display: none !important;
  }

  .main-menu {
    display: none !important;
  }

  .content-header {
    display: none !important;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
  }

  .mycolor{
    background-color:#EA2F2F ;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  .contact {
    background-color: #EA2F2F;
    padding: 20px;
    border-radius: 25px;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  footer footer-light footer-static {
    display: inline-block;
  }

  footer.footer {
    display: none !important;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;

    .row.invoice-preview {
      width: 100% !important;
      margin: 0 !important;

      .col-md-8 {
        max-width: 100% !important;
        width: 100% !important;
        flex-grow: 1;
        padding: 0 !important;
      }

      .invoice-preview-card {
        height: 50vh !important;
        max-height: 50vh !important;
        min-height: 50vh !important;
        margin: 0 !important;
        border: none !important;

        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none !important;
    }
  }

  // Overlay should be hidden when printing
  .b-overlay {
    display: none !important;
  }

  table,
  td,
  th {
    padding: 8px !important;
    text-align: left;
    border: 1px solid black;
    font-size: 14px !important;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
}
</style>
